<template>
    <div class="adm-content-item" v-if="value">
        <h5 class="adm-content-item__title">
            <span style="color:#3C3C3C">{{ !!value.abbreviation ? value.abbreviation : ''}}</span>
        </h5>
        <div class="adm-content-item__detail">
            <div class="adm-content-item__meta">
                <div>年份：{{value.year}}</div>
                <div>行业：{{value.industry}}</div>
            </div>
            <div class="adm-content-item__meta">
                <div :title="value.yearReport">年报：{{value.yearReport || '暂无'}}</div>
                <div :title="value.socialReport">社报：{{value.socialReport || '暂无'}}</div>
            </div>
            <div v-if="type == 'carbon'" class="adm-content-item__meta" style="align-content: flex-end;">
                <div>指标录入：
                    <ivProgress
                      :percent="value.carbonInputRate || 0"
                      style="width: 180px;"
                    />
                     <a href="javascript:;" @click="$emit('showReportData',{ type:'carbon', value: value } )" style="position:relative; z-index:99; margin-right: 30px;">点击查看</a>
                </div>
            </div>
            <div v-else class="adm-content-item__meta">
                <div>年报录入：
                    <ivProgress
                      :percent="value.yearInputRate || 0"
                      style="width: 180px;"
                    />
                    <a href="javascript:;" @click="$emit('showReportData',{ type:'year', value: value })" style="position:relative; z-index:99; margin-right: 30px;">点击查看</a>
                </div>
                <div>社报录入：
                    <ivProgress
                      :percent="value.socialInputRate || 0"
                      style="width: 180px;"
                    />
                     <a href="javascript:;" @click="$emit('showReportData',{ type:'social', value: value } )" style="position:relative; z-index:99; margin-right: 30px;">点击查看</a>
                </div>
            </div>
            <div class="adm-content-item__meta">
                <div>录入人：{{value.editor || '暂无' }}</div>
                <div>审核人：{{value.reviewer || '暂无' }}</div>
            </div>
            <slot />
        </div>
          <iv-modal
            :mask-closable="false"
            title="修改标题"
            width="450"
            :closable="false"
            v-model="EditTitle"
            @on-cancel="EditTitle = false">
                    <iv-form :model="formValidate" :rules="ruleValidate" ref="formValidate" label-position="top" inline>
                        <iv-form-item label="标题" prop="title">
                            <iv-input type="text" v-model="formValidate.title" placeholder="请输入标题" style="width:400px"></iv-input>
                        </iv-form-item>
                    </iv-form>
                <iv-button type="text" size="large" slot="footer" @click="EditTitle = false">取消</iv-button>
                <iv-button type="primary" size="large" slot="footer" @click="update">确定</iv-button>
        </iv-modal>
    </div>
</template>
<style lang="scss" scoped>
.adm-content-item{
    // padding: 10px 0;
    color: #999999;
    .search-text{
        color: #e94949;
    }
    &__title{
        font-size: 12px;
        margin-bottom: .5em;
        padding: 5px 10px 0 10px;
        small{
            color: #aaa;
            font-weight: normal;
            margin-left: .625em;
        }
        .item_edit{
            color:#2d8cf0;
            &:hover{
                cursor: pointer;
            }
        }
    }
    &__detail{
        display: flex;
        justify-content: space-between;
    }
    &__meta{
        padding: 0 10px;
        flex-grow: 1;
        &:nth-child(1),&:nth-child(2),&:nth-child(3){
            position: relative;
            &::after{
                content:'';
                height: 50px;
                width: 1px;
                border-right: 1px solid #DDDDDD;
                position: absolute;
                right: 0;
                top: 0;
            }
        }
        &:nth-child(2){
            width: 200px;
        }
        &:nth-child(4){
            width: 150px;
            flex-grow: 0;
        }
        > div{
            height: 24px;
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            display: block;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
        }
        .negative > .ivu-select >>> .ivu-select-selection{
            background: #ED4C4C;
        }
        .positive > .ivu-select >>> .ivu-select-selection{
            background: #33AB15;
        }
        .item_section{
            overflow: hidden;
            text-overflow: ellipsis;
            display:-webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient:vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp:1; //显示的行
        }
    }

    &__content{
        display: flex;
        justify-content: space-between;
    }
    &__buttons{
        opacity: 1;
        transition: opacity .5s ease-out;
        a, button {
            margin-left: .625em;
            &:first-child{
                margin-left: 0;
            }
        }
    }
    &__type{
        vertical-align: middle;
        margin-left: 7px;
    }
    &__read{
        color: #2d8cf0;
    }
    &__exclude{
        color: #ED4C4C;
    }
}
</style>
<script>
    export default {
    props: {
        value: Object,
        type:''
    },
    data(){
        return {
            EditTitle:false,
            formValidate:{},
            ruleValidate:{
                title: [
                        { required: true, message: '请输入标题', trigger: 'change' }
                ],
            }
        }
    },
    methods: {
        find(arr, val, field="id"){
            return arr.find(item=>item[field] == val) || {}
        },
        clickHandle(val) {
            this.$emit('confirm', { id: this.value.id , is_confirm:val })
        },
        async update(){
            this.$refs.formValidate.validate((valid) => {
                if (valid) {
                    this.$emit('title',{ id: this.value.id , title:this.formValidate.title })
                    this.$$success(`标题成功修改为${ this.formValidate.title }`)
                    this.EditTitle = false
                }
            })
        },
        editVal(){
            this.EditTitle = true
            this.formValidate.title = this.value.title
        }
    },
}
</script>
